export default "__VITE_ASSET__1d2ba93c__"